const initState = {
  contestData: [],
  schoolAthletes: [],
  schoolFans: [],
  isLoading: false,
  loadmoreLoader: false,
  fansLastDocument: null,
  fansMoreDocuments: true,
  athletesLastDocument: null,
  athletesMoreDocuments: true,
  rejectedSuggestedUsers: [],
  suggestedAthletes: [],
};
const athletesReducer = (state = initState, action) => {
  switch (action.type) {
    case "GET_SUGGESTED_ATHLETES":
      return {
        ...state,
        suggestedAthletes: action.payload,
      };
    case "REJECTED_SUGGESTED_USERS":
      return {
        ...state,
        rejectedSuggestedUsers: action.payload,
      };
    case "GET_SPORT_CONTEST_DATA":
      return {
        ...state,
        contestData: action.payload,
      };
    case "SET_SCHOOL_ATHLETES":
      return {
        ...state,
        schoolAthletes: action.payload.data,
        athletesLastDocument: action.payload.lastDocument,
        athletesMoreDocuments: action.payload.hasMoreDocuments,
      };
    case "SET_SCHOOL_FANS":
      return {
        ...state,
        schoolFans: action.payload.data,
        fansLastDocument: action.payload.lastDocument,
        fansMoreDocuments: action.payload.hasMoreDocuments,
      };
    case "SET_FANS_ATHLETES_LOADER":
      return {
        ...state,
        isLoading: action.payload,
      };
    case "SET_FANS_ATHLETES_LOADMORELOADER":
      return {
        ...state,
        loadmoreLoader: action.payload,
      };
    default:
      return {
        ...state,
      };
  }
};
export default athletesReducer;
